export enum DisplayType {
  None,
  Info,
  Success,
  Danger,
  Warning,
}

export type WindowSizes = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
